import { useEffect, useState } from "react";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
);

export default function Confirm() {
  const [message, setMessage] = useState("Verifying your email...");

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        // New flow: read token_hash + type from query string
        const searchParams = new URLSearchParams(window.location.search);
        const token_hash = searchParams.get("token_hash");
        const type = searchParams.get("type");

        console.log("🔍 token_hash:", token_hash);
        console.log("🔍 type:", type);

        if (!token_hash || !type) {
          setMessage("Verification failed. Invalid or expired link.");
          return;
        }

        // 1) Verify OTP
        const { error: verifyError } = await supabase.auth.verifyOtp({
          token_hash,
          type,
        });

        if (verifyError) {
          console.error("❌ verifyOtp error:", verifyError);
          setMessage("Verification failed. Invalid or expired link.");
          return;
        }

        // 2) Get confirmed user
        const {
          data: { user },
          error: userError,
        } = await supabase.auth.getUser();

        if (userError || !user) {
          console.error("❌ getUser error:", userError);
          setMessage("Verification failed. Please try logging in.");
          return;
        }

        console.log("✅ Supabase user:", user);

        // 3) Call backend to create profile linked to existing clinic
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/create-clinic-profile`;
        console.log("📡 Calling backend:", apiUrl);

        const res = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: user.id,
            email: user.email,
            full_name: user.user_metadata?.full_name || "",
          }),
        });

        const result = await res.json();
        console.log("📥 create-clinic-profile result:", result);

        if (!res.ok) {
          throw new Error(result.detail || "Account setup failed");
        }

        setMessage("✅ Email confirmed! Your account is ready.");
        setTimeout(() => {
          window.location.href = "/";
        }, 3000);
      } catch (err) {
        console.error("❌ Backend error:", err);
        setMessage(`Email confirmed, but account setup failed: ${err.message}`);
      }
    };

    confirmEmail();
  }, []);

  return (
    <div style={{ padding: "2rem", textAlign: "center", fontFamily: "sans-serif" }}>
      <h2>{message}</h2>
      {message.includes("confirmed") && <p>Redirecting to login...</p>}
    </div>
  );
}

